<template>
    <div>
        <template v-if="add_test_screen">
            <q-alert v-if="hasResults" color="warning" icon="fal fa-exclamation-triangle" class="q-mb-sm">
                {{ $t('test_has_user_results') }}
            </q-alert>

            <div class="row gutter-sm">
                <div class="col-xs-12 col-sm-12">
                    <q-select  v-model="event_date_test_type" :options="test_types.map(e => ({ label: $t(e.slug), value: e.value }))" :float-label="$t('test_type')" :error="$v.event_date_test_type.$error" @input="$v.event_date_test_type.$touch" :disable="hasResults" />
                </div>

                <div class="col-xs-12 col-sm-12" v-if="event_date_test_type">
                    <q-alert color="secondary" icon="fal fa-exclamation-triangle">
                        {{ $t(getTestTypeDescription) }}
                    </q-alert>
                </div>

                <div class="col-xs-12 col-sm-12">
                    <q-field :count="256">
                        <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                    </q-field>
                </div>

                <div class="col-xs-12 col-sm-12" v-if="testProperties.use_max_attempts">
                    <q-input v-model="maximum_attempts" :float-label="$t('maximum_attempts_quantity')" :error="$v.maximum_attempts.$error" @input="$v.maximum_attempts.$touch" :disable="hasResults" />
                </div>

                <div  class="col-xs-12 col-sm-12"  v-if="testProperties.use_time" v-show="event_date_test_type === 6 || event_date_test_type === 7">
                    <q-datetime type="time" v-model="time_to_answer" :float-label="$t('time_to_answer')" :error="$v.time_to_answer.$error"  @input="$v.time_to_answer.$touch" :disable="hasResults" format="HH:mm:ss" />
                </div>

                <div class="col-xs-12 col-sm-6">
                    <q-datetime v-model="avaliable_in" type="date" :float-label="$t('avaliable_in')" format="DD/MM/YYYY" clearable />
                </div>

                <div class="col-xs-12 col-sm-12">
                    <q-field :helper="$t('leave_it_blank_to_use_training_score')">
                        <q-input v-model="test_score" type="number" :float-label="$t('test_score')" :error="$v.test_score.$error" @input="$v.test_score.$touch" />
                    </q-field>
                </div>

                <div class="col-xs-12 col-sm-6">
                    <p class="caption">{{ $t('random_questions') }}</p>
                    <q-btn-toggle v-model="randomize_questions" :toggle-color="getColorRandomizeQuestions" :options="randomize_questions_options" />
                </div>

                <div class="col-xs-12 col-sm-6">
                    <p class="caption">{{ $t('random_answers') }}</p>
                    <q-btn-toggle v-model="randomize_answers" :toggle-color="getColorRandomizeAnswers" :options="randomize_answers_options" />
                </div>
            </div>

            <q-table
                :data="questions"
                :columns="columns_questions"
                :pagination.sync="server_pagination"
                @request="request_questions"
                :loading="loading"
                row-key="id"
                :no-data-label="$t('no_data_avaliable')"
                :no-results-label="$t('no_results_found')"
                :loading-label="$t('loading_data')"
                :rows-per-page-label="$t('items_per_page')"
                :rows-per-page-options="[0]"
                binary-state-sort
                class="q-mt-lg"
                >
                <template slot="top" slot-scope="props" :props="props">
                    <div class="q-table-title">{{ $t('questions') }}</div>
                    <div class="col" />
                    <q-btn class="q-mr-sm" v-if="questions.length > 0" color="secondary" icon="far fa-ballot-check" :label="$t('preview')" @click="show_test_preview = true"  />
                    <q-btn class="q-mr-sm" color="secondary" icon="far fa-file-upload" :label="$t('import_test')" @click="importTest(0)"  :disable="hasResults" />
                    <q-btn color="secondary" icon="far fa-plus" :label="$t('new')" @click="showQuestion(0)"  :disable="hasResults" />
                </template>

                <q-tr slot="header" slot-scope="props" :props="props">
                    <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                    </q-th>
                </q-tr>

                <q-tr slot="body" slot-scope="props" :props="props">
                    <q-td auto-width key="id" :props="props">
                        {{ props.row.id }}
                    </q-td>

                    <q-td key="title" :props="props">
                        {{ props.row.title.substring(0, 100) }}
                    </q-td>

                    <q-td key="qty_answers" :props="props">
                        {{ props.row.qty_answers }}
                    </q-td>

                    <q-td key="is_mandatory" auto-width :props="props">
                        <q-icon :name="props.row.is_mandatory ? 'fas fa-check' : 'fas fa-ban'" :color="props.row.is_mandatory ? 'positive' : 'negative'" size="1.2rem" />
                    </q-td>

                    <q-td auto-width key="status" :props="props">
                        <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                            {{ $t(getStatus(props.row.status)) }}
                        </q-chip>
                    </q-td>

                    <q-td auto-width key="actions" :props="props">
                        <q-btn flat round color="primary" icon="far fa-pencil-alt" @click="showQuestion(props.row.actions)" >
                            <q-tooltip>
                                {{ $t('view_or_edit_tooltip') }}
                            </q-tooltip>
                        </q-btn>

                        <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" :disable="hasResults" >
                            <q-tooltip>
                                {{ $t('delete_tooltip') }}
                            </q-tooltip>
                        </q-btn>
                    </q-td>
                </q-tr>
            </q-table>

            <div class="row gutter-sm q-mt-md">
                <div class="col-xs-12 col-sm-12">
                    <q-input v-model="qty_total_questions" :float-label="$t('number_of_exam_questions_leave_blank_to_use_all')" :error="$v.qty_total_questions.$error" @input="$v.qty_total_questions.$touch" :disable="hasResults" />
                </div>

                <div class="col-xs-12 col-sm-12" v-if="testProperties.use_minimum_score">
                    <q-input v-model="minimum_score" :float-label="$t('minimum_score_approval')" :error="$v.minimum_score.$error" @input="$v.minimum_score.$touch" :disable="hasResults" />
                </div>

                <div class="col-xs-12 col-sm-4">
                    <p class="caption">{{ $t('status') }}</p>
                    <q-btn-toggle v-model="status" :toggle-color="getColorStatusButton" :options="statuses" />
                </div>
            </div>

            <div class="row gutter-sm justify-end q-mt-lg">
                <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                    <q-btn color="tertiary" class="full-width" :label="$t('event')" icon="far fa-chevron-left" @click="returnToTests()" />
                </div>

                <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                    <q-btn color="secondary" class="full-width" :label="$t('save_test')" icon="far fa-save" @click="saveTest('save_test')" />
                </div>
            </div>
        </template>

        <q-dialog v-model="confirm_remove" @ok="removeItem">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
            </template>
        </q-dialog>

        <new-question :id_training="id_training" :id_event="id_event" :id_test="id_test" :id_question="id_question" :add_question="add_question" :has_results="hasResults" @returnToQuestions="returnToQuestions()" />

        <import-test :id_test="id_test" :import_test="import_test" :has_results="hasResults" @returnToQuestions="returnToQuestions()" />

        <test-preview v-if="show_test_preview" :show_test_preview="show_test_preview"
            :title="title"
            :questions="questions"
            :randomize_questions="randomize_questions"
            :randomize_answers="randomize_answers"
            @returnToQuestions="returnToQuestions()" />
    </div>
</template>


<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, maxValue, minValue, maxLength } from 'vuelidate/lib/validators'
import NewQuestion from 'components/admin/presential/tests/TestsTabNewQuestion'
import ImportTest from 'components/admin/presential/tests/ImportTest'
import { date } from 'quasar'
const { formatDate, buildDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    props: ['add_test_screen', 'id_training', 'id_event', 'id_test', 'test_types'],

    i18nOptions: { namespaces: [ 'custom', 'common', 'presential', 'training', 'admin', 'imports'] },

    data() {
        return {
            action_id: null,
            add_question: false,
            avaliable_in: null,
            columns_questions: [
                {
                    align: 'left',
                    field: 'id',
                    label: '#',
                    name: 'id',
                    required: true,
                    sortable: false,
                },
                {
                    align: 'left',
                    field: 'title',
                    label: 'question',
                    name: 'title',
                    required: true,
                    sortable: false,
                },
                {
                    align: 'left',
                    field: 'qty_answers',
                    label: 'alternative_quantity',
                    name: 'qty_answers',
                    required: true,
                    sortable: false,
                },
                {
                align: 'center',
                field: 'is_mandatory',
                label: 'mandatory',
                name: 'is_mandatory',
                required: true,
                sortable: false
                },
                {
                    align: 'left',
                    field: 'status',
                    label: 'status',
                    name: 'status',
                    required: true,
                    sortable: false,
                },
                {
                    align: 'left',
                    field: 'actions',
                    label: '',
                    name: 'actions',
                    required: true,
                    sortable: true,
                }
            ],
            confirm_remove: false,
            event_date_test_type: '',
            id_question: '',
            import_test: false,
            loading: false,
            maximum_attempts: '',
            minimum_score: '',
            qty_total_questions: '',
            qty_user_results: '',
            questions: [],
            randomize_answers: true,
            randomize_answers_options: [
                {
                    label: this.$t('yes'),
                    value: true
                },
                {
                    label: this.$t('no'),
                    value: false
                }
            ],
            randomize_questions: true,
            randomize_questions_options: [
                {
                    label: this.$t('yes'),
                    value: true
                },
                {
                    label: this.$t('no'),
                    value: false
                }
            ],
            server_pagination: {
                descending: false,
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                sortBy: null
            },
            show_test_preview: false,
            status: 2,
            statuses: [
                {
                    label: this.$t('published_f'),
                    value: 1
                },
                {
                    label: this.$t('unpublished_f'),
                    value: 2
                }
            ],
            test_score: null,
            time_to_answer: '',
            title: '',
        }
    },

    components: {
        'new-question': NewQuestion,
        'import-test': ImportTest,
        'test-preview': () => import('components/admin/shared/tests/TestPreviewModal')
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            presential_event_date_test_types: 'registration_lists/presential_event_date_test_types'
        }),

        getHeader() {
            let headers = {}
            return {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getColorRandomizeQuestions() {
            if (this.randomize_questions == true) return 'positive'
            else return 'negative'
        },

        getColorRandomizeAnswers() {
            if (this.randomize_answers == true) return 'positive'
            else return 'negative'
        },

        getColorStatusButton() {
            if (this.status == true) return 'positive'
            else return 'negative'
        },

        testProperties() {
            let obj = this.presential_event_date_test_types.find((obj) => { return obj.value === this.event_date_test_type })
            if (obj) return obj
            else {
                return {
                    use_max_attempts: false,
                    use_minimum_score: false,
                    use_time: false
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        hasResults() {
            if (this.qty_user_results > 0) return true
            return false
        },

        getTestTypeDescription() {
            let slug = this.getTestTypeSlug(this.event_date_test_type)
            return `${slug}_description`
        },
    },

    methods: {
        request_questions ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination
            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''
            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }
            this.$axios.get(`/presential/presential_events/${this.id_training}/event_dates/${this.id_event}/event_date_tests/${this.id_test}/event_date_test_questions/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.questions = response.data.results
                    ? response.data.results.map(question => {
                        return {
                            ...question,
                            status: 1,
                            actions: question.id,
                            answers: question.event_date_test_question_answers
                        }
                    })
                    : []
                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        loadTest() {
            if (this.id_test != 0) {
                this.$q.loading.show()
                this.$axios.get(`/presential/presential_events/${this.id_training}/event_dates/${this.id_event}/event_date_tests/${this.id_test}/`, this.getHeader)
                .then(response => {
                    this.title = response.data.title
                    this.event_date_test_type = response.data.event_date_test_type
                    this.qty_questions = response.data.qty_questions
                    this.randomize_questions = response.data.randomize_questions
                    this.randomize_answers = response.data.randomize_answers
                    this.minimum_score = response.data.minimum_score
                    this.maximum_attempts = response.data.maximum_attempts
                    this.status = response.data.status
                    this.qty_user_results = response.data.qty_user_results
                    this.avaliable_in = response.data.avaliable_in ? moment(response.data.avaliable_in).tz('Etc/GMT').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
                    this.test_score = response.data.test_score != 0 ? response.data.test_score : null
                    this.qty_total_questions = response.data.qty_total_questions

                    if (response.data.time_to_answer) {
                        let time = response.data.time_to_answer.split(':')
                        this.time_to_answer = date.buildDate({ hours: time[0], minutes: time[1], seconds: time[2]})
                    }

                    this.$q.loading.hide()
                    this.add_test_screen = true
                    this.request_questions({ pagination: this.server_pagination })
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
            else {
                this.questions = []
                this.title = ''
                this.event_date_test_type = ''
                this.randomize_questions = true
                this.randomize_answers = true
                this.minimum_score = ''
                this.maximum_attempts = ''
                this.time_to_answer = ''
                this.status = 2
                this.add_test_screen = true
                this.qty_user_results = ''
            }
        },

        showQuestion(id) {
            this.$v.$touch()
            this.id_question = id

            if (!this.$v.$error) {
                this.saveTest('add_question')
            }
            else{
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        importTest(id) {
            this.$v.$touch()
            this.id_question = id

            if (!this.$v.$error) {
                this.saveTest('import_test')
            }
            else{
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        saveTest(type) {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('title', this.title)
                fd.append('event_date_test_type', this.event_date_test_type)
                fd.append('status', this.status)
                fd.append('randomize_questions', this.randomize_questions)
                fd.append('randomize_answers', this.randomize_answers)
                fd.append('qty_total_questions', this.qty_total_questions ? this.qty_total_questions : '')

                fd.append('avaliable_in', this.avaliable_in ? date.formatDate(this.avaliable_in, 'YYYY-MM-DD') : '')
                if (this.test_score) fd.append('test_score', this.test_score)

                if (this.testProperties.use_minimum_score && this.minimum_score != '' && this.minimum_score != null) fd.append('minimum_score', this.minimum_score)
                if (this.testProperties.use_max_attempts) fd.append('maximum_attempts', this.maximum_attempts)
                if (this.testProperties.use_time && this.event_date_test_type === 6 || this.event_date_test_type === 7) fd.append('time_to_answer', date.formatDate(this.time_to_answer, 'HH:mm:ss'))

                if (this.id_test != 0) {
                    this.$axios.put(`/presential/presential_events/${this.id_training}/event_dates/${this.id_event}/event_date_tests/${this.id_test}/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.$v.$reset()

                        if (type == 'add_question') {
                            this.add_question = true
                        } else if (type === 'import_test') {
                            this.import_test = true
                        }
                        else {
                            this.$q.notify({
                                message: this.$t('test_edit_success'),
                                type: 'positive',
                                icon: 'fal fa-save'
                            })

                            this.returnToTests()
                        }
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('test_edit_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })

                        console.log(e)
                    })
                }
                else {
                    this.$axios.post(`/presential/presential_events/${this.id_training}/event_dates/${this.id_event}/event_date_tests/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.$v.$reset()

                        this.$q.notify({
                            message: this.$t('test_add_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.$emit('changeIdTest', response.data.id)

                        if (type == 'add_question') {
                            this.add_question = true
                        } else if (type === 'import_test') {
                            this.import_test = true
                        }
                        else {
                            this.returnToTests()
                        }
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('test_add_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })

                        console.log(e)
                    })
                }
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        getTestTypeSlug(id) {
            let obj = this.test_types.find((obj) => { return obj.value === id })
            if (obj) return obj.slug
            else return ''
        },

        getStatus(status) {
            if (status == 1) return 'published_f'
            else if (status == 2) return 'unpublished_f'
            else if (status == 3) return 'deleted'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        returnToTests() {
            this.questions = []
            this.title = ''
            this.event_date_test_type = ''
            this.randomize_questions = true
            this.randomize_answers = true
            this.minimum_score = ''
            this.maximum_attempts = ''
            this.time_to_answer = ''
            this.status = 2
            this.add_test_screen = true
            this.qty_user_results = ''
            this.avaliable_in = null
            this.test_score = null

            this.$v.$reset()

            this.$emit('returnToTests', '')
        },

        returnToQuestions() {
            this.request_questions({
                pagination: this.server_pagination
            })

            this.id_question = ''
            this.add_question = false
            this.import_test = false
            this.show_test_preview = false
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeItem() {
            this.$q.loading.show()
            this.$axios.delete(`/presential/presential_events/${this.id_training}/event_dates/${this.id_event}/event_date_tests/${this.id_test}/event_date_test_questions/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.request_questions({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },
    },

    watch: {
        id_test: function() {
            if (this.id_test != 0) this.loadTest()
        }
    },

    validations() {
        return {
            title: { required, maxLength: maxLength(256)},
            event_date_test_type: { required },
            minimum_score: {
                requiredIf: requiredIf(() => {
                    return this.testProperties.use_minimum_score && this.status == 1 ? true : false
                }),
                maxValue: maxValue(this.questions.length),
                minValue: minValue(this.testProperties.use_minimum_score && this.questions.length > 0 ? 1 : '')
            },
            maximum_attempts: {
                requiredIf: requiredIf(() => {
                    return this.testProperties.use_max_attempts
                }),
                minValue: minValue(this.testProperties.use_max_attempts ? 1 : 0)
            },
            time_to_answer: {
                requiredIf: requiredIf(() => {
                    return this.testProperties.use_time && (this.event_date_test_type === 6 || this.event_date_test_type === 7) ? true : false
                })
            },
            test_score: {
                minValue: minValue(0)
            },
            qty_total_questions: {
                minValue: minValue(this.questions.filter(e => e.is_mandatory).length),
                maxValue: maxValue(this.questions.length)
            }
        }
    }
}
</script>

<style>
</style>
